import axios from '@/axios.js'

export default {
  async fetchStats({ commit })  {
    commit('STATS', null);
    commit('COINS', null);
    const request = await axios.get('/specialist/stats');

    if (request.status === 200) {
      commit('STATS', request.data);
      commit('COINS', request.data.credits);
    }
  },
  async fetchSales({ state, commit }, period)  {
    commit('SALES', null);
    commit('COINS', null);
    const request = await axios.get('/specialist/stats/sales?period=' + period);

    if (request.status === 200) {
        commit('SALES', request.data);
        commit('COINS', request.data.credits);
    }
  },
  async fetchActivity({ commit }, { year, month })  {
    commit('ACTIVITY', null);
    const request = await axios.get(`/specialist/stats/activity/${ year }/${ month }`);

    if (request.status === 200) {
        commit('ACTIVITY', request.data);
    }
  },
}
